import {CircularProgress} from '@mui/material'
import DataRefetchOnError from '../../common/DataFetchError/DataRefetchOnError'
import MultiSelectDropdownComponent from '../../common/MulitSelectDropdown/MultiSelectDropdownComponent'
import {DropdownLoadingBox} from '../Jurisdiction/JurisdictionStyle'
import {SharedSubTitle} from '../../common/SharedSubTitleStyle'
import loadingTitles from '../../../appConfig/loadingTitles.config.json'
import PropTypes from 'prop-types'
import {StyledSectionTitle} from '../../AdminPanelStyling'
import {useProjectDetails} from '../../../store/hooks/projectDetails'
import {useFilterConfig} from '../../../store/hooks/config'

const HomeAndHouseholdFilterComponent = ({
  selectedData,
  setFilterValue,
  handleOptionDeletion,
  enabled,
  isCompleted,
  showCustomLabels,
  setCustomLabelDialogProps,
  hasAnyFilters
}) => {
  const {filterDetailsLoading, filterDetailsError, refetchFilterDetailsList} = useProjectDetails()
  const filterConfig = useFilterConfig()

  function refetchHealthAndConditions(event) {
    event.preventDefault()
    refetchFilterDetailsList()
  }

  const renderDropdown = () => {
    if (filterDetailsLoading) {
      return (
        <DropdownLoadingBox>
          <CircularProgress title={loadingTitles.homeAndHouseholdBreadcrumb} />
        </DropdownLoadingBox>
      )
    }

    if (!filterDetailsLoading && filterDetailsError) {
      return <DataRefetchOnError onTryAgain={(event) => refetchHealthAndConditions(event)} />
    }

    const homeAndHouseholdSection = filterConfig?.data?.find((section) => section.id === '4')
    const homeAndHouseholdKeys = homeAndHouseholdSection?.filters?.map((filter) => filter.key) || []
    const homeAndHouseholdFilters =
      homeAndHouseholdSection?.filters.map((filter) => ({
        title: filter.name,
        FILTER_KEY: filter.key,
        FILTER_ID: filter.key,
        IS_ACTIVE: true
      })) || []

    const sortedHealthCondition = homeAndHouseholdFilters.sort((a, b) => {
      if (a.title < b.title) return -1
      if (a.title > b.title) return 1
      return 0
    })

    // Predicate to check if filter belongs to Home and Household section
    const isHomeAndHouseholdFilter = (filter) => homeAndHouseholdKeys.some((key) => filter.FILTER_KEY?.startsWith(key))

    // Filter selectedData to only include Home and Household filters
    const selectedHomeAndHouseholdFilters = selectedData?.filter(isHomeAndHouseholdFilter) || []

    // Wrapper to merge with other filter sections
    const handleHomeAndHouseholdChange = (newFilters) => {
      const otherFilters = selectedData?.filter((filter) => !isHomeAndHouseholdFilter(filter)) || []
      setFilterValue([...otherFilters, ...newFilters])
    }

    return (
      <MultiSelectDropdownComponent
        selectAllTitle='Select All'
        dropDownTitle='Select'
        inputAndPreviewTitle='Home and Household'
        dropDownModifiedTitle='Selected'
        dropDownData={sortedHealthCondition}
        val={selectedHomeAndHouseholdFilters}
        setVal={handleHomeAndHouseholdChange}
        enabled={enabled}
        isCompleted={isCompleted}
        handleOptionDeletion={(type, data, option) => handleOptionDeletion(type, data, option)}
        hasAnyFilters={hasAnyFilters}
        isFilterDropdown={true}
        section='Home and Household'
        setCustomLabelDialogProps={setCustomLabelDialogProps}
        showCustomLabels={showCustomLabels}
      />
    )
  }
  return (
    <>
      <StyledSectionTitle variant='h5'> What Home and Household filters do you want available? </StyledSectionTitle>
      <SharedSubTitle>This is what your client will see when interacting with data on their dashboard</SharedSubTitle>
      {renderDropdown()}
    </>
  )
}

HomeAndHouseholdFilterComponent.propTypes = {
  selectedData: PropTypes.array.isRequired,
  setFilterValue: PropTypes.func.isRequired,
  handleOptionDeletion: PropTypes.func,
  enabled: PropTypes.bool.isRequired,
  isCompleted: PropTypes.bool.isRequired,
  showCustomLabels: PropTypes.bool,
  setCustomLabelDialogProps: PropTypes.func,
  hasAnyFilters: PropTypes.bool
}

export default HomeAndHouseholdFilterComponent
